export const dataPropertyType = -772;
export const numericPropertyType = 82;
export const textPropertyType = 83;
